var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortNoneChevrons = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 11.75L9 14.5625L6.1875 11.75",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 11.75L9 14.5625L6.1875 11.75H11.8125Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 7.0625L9 4.25L11.8125 7.0625",
    fill: "#9CA3AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 7.0625L9 4.25L11.8125 7.0625L6.1875 7.0625Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortNoneChevrons);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-none-chevrons.9f9418779572042a9d636a35dd01612a.svg";